import styled from "styled-components";

import LogoDefault from "components/Logo";
import DefaultRow from "components/Form/Row";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  padding: 60px 48px 60px;

  width: 392px;
`;

export const Logo = styled(LogoDefault)`
  margin-bottom: 46px;
`;

export const Row = styled(DefaultRow)`
  margin-bottom: 56px;
`;

export const ButtonWrapper = styled.div`
  padding-top: 22px;
`;
